export default "__VITE_ASSET__e2de5246__"